import React, { useEffect, useState } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Breadcrumb, Tag, Switch } from 'antd';
import { makeStyles } from '@material-ui/core';
import Modal from '../../../component/Modal/Modal';
import ArrowNextIcon from '../../../asset/arrow-next.svg';
import CButton from '../../../component/Button';
import Loader from '../../../component/Loader/Loader';
import {
  fetchCategoryAction,
  fetchCategoriesAction,
  updateCategoryAction,
  setCategoryDraft,
  cleanupAction,
  deleteCategoryAction
} from '../../../actions/categoriesActions';
import NoxTable from '../../../component/Table';

import { CStandardInput } from '../../../component/Input';
import formatDate from '../../../helpers/formatDate';
import { MultipleSelect } from '../../../component/Select';

const useStyles = makeStyles({
  actionBar: {
    border: '1px solid #CAD8FF',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: '50px',
    padding: '35px 0px',
    width: '100%'
  },
  gridContainer: {
    display: 'grid',
    gridRowGap: '25px',
    gridTemplateColumns: '33% 33% 34%',
    marginTop: '0px',
    width: '100%'
  },
  gridHeader: {
    textAlign: 'start'
  },
  gridHeaderSelect: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%',
    margin: '0px',
    transform: 'translate(-25px, -5px) scale(0.83)'
  },
  gridHeaderSwitch: {
    margin: '0px',
    marginTop: '20px',
    textAlign: 'start'
  },
  gridItem: {
    maxWidth: '230px',
    textAlign: 'start'
  },
  p: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%'
  },
  root: {
    ' & .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      height: '40px',
      padding: '14px 16px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9BA0AD'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '10px',
      top: '7px'
    },
    '& .MuiInputLabel-shrink': {
      fontFamily: 'Poppins',
      transform: 'translate(-10px, -10px) scale(0.83)'
    }
  },
  select: {
    '& .MuiSelect-root': {
      padding: '9px'
    },
    borderRadius: '10px',
    marginLeft: '8px',
    maxHeight: '40px ',
    padding: '0px',
    width: '180px'
  },
  span: {
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500
  },
  switch: {
    marginLeft: '12px'
  }
});

const CategoryDetail = () => {
  const { categoryId } = useParams();
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const optionsMap = ['material', 'color', 'size', 'age', 'quantity'];
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const currentProject = useSelector(({ project }) => project.currentProject);

  useEffect(() => {
    async function load() {
      dispatch(fetchCategoriesAction());
      dispatch(fetchCategoryAction(categoryId));
    }

    if (currentProject) {
      load();
    }

    return dispatch(cleanupAction());
  }, [currentProject, dispatch, categoryId]);

  const selectedCategoryDraft = useSelector(({ categories }) => categories.selectedCategoryDraft);
  const selectedCategoryEdit = useSelector(({ categories }) => categories.selectedCategoryEdit);
  const categories = useSelector(({ categories }) => categories.categories);

  const columns = [
    {
      dataIndex: 'name',
      key: 'name',
      render: (name) => {
        return (
          <div
            style={{
              color: 'black',
              fontWeight: 700
            }}
          >
            {name}
          </div>
        );
      },
      sorter: (a, b) => a.name.localeCompare(b.name),
      title: 'Name'
    },
    {
      dataIndex: 'category',
      key: 'category',
      sorter: (a, b) => a.category.localeCompare(b.category),
      title: 'Category'
    },
    {
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      sorter: (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt),
      title: 'Updated At'
    },
    {
      dataIndex: 'isEnabled',
      key: 'isEnabled',
      render: (isEnabled, category) => {
        return (
          <Switch
            defaultChecked={isEnabled}
            onChange={(isEnabled) => {
              return dispatch(
                updateCategoryAction(
                  category._id,
                  {
                    ...category,
                    isEnabled
                  },
                  () => {
                    // dispatch(fetchCategoriesAction());
                  }
                )
              );
            }}
          />
        );
      },
      sorter: (a, b) => a.isEnabled.toString().localeCompare(b.isEnabled.toString()),
      title: 'Enable'
    },
    {
      dataIndex: 'buyButton',
      key: 'buyButton',
      render: (buyButton, category) => {
        return (
          <Switch
            defaultChecked={buyButton}
            onChange={(buyButton) => {
              return dispatch(
                updateCategoryAction(
                  category._id,
                  {
                    ...category,
                    buyButton
                  },
                  () => {
                    // dispatch(fetchCategoriesAction());
                  }
                )
              );
            }}
          />
        );
      },
      sorter: (a, b) => a.buyButton.toString().localeCompare(b.buyButton.toString()),
      title: 'Buy Button'
    },
    {
      key: 'edit',
      render: (category) => (
        <Tag
          onClick={() => {
            openDetail(category);
          }}
        >
          Edit
        </Tag>
      )
    }
  ];

  const openDetail = (item) => {
    history.push({
      pathname: `/ecommerce/categories/${item._id}`
    });
  };

  function itemRender(route, params, routes) {
    const last = routes.indexOf(route) === routes.length - 1;
    return last ? (
      <span>{route.breadcrumbName}</span>
    ) : (
      <Link to={route.path}>{route.breadcrumbName}</Link>
    );
  }

  const routes = [
    {
      breadcrumbName: 'Categories',
      path: '/ecommerce/categories'
    },
    {
      breadcrumbName: selectedCategoryEdit._id || '-',
      path: `/ecommerce/categories/${categoryId}`
    }
  ];

  const mapToTable = (customer) => {
    const data = [];

    if (!customer || customer.length === 0) {
      return data;
    }

    customer.forEach(({ _id, name, updatedAt, isEnabled, order, buyButton, parentId }, index) => {
      const date = formatDate(updatedAt);
      const category = selectedCategoryEdit?.name ?? '-';
      data.push({
        _id,
        buyButton,
        category,
        isEnabled,
        key: index,
        name,
        order,
        parentId,
        updatedAt: date.toString() === 'Inv' ? '-' : date
      });
    });

    data.sort((a, b) => a.order - b.order);

    return data;
  };

  const data = mapToTable(
    categories.filter((category) => category._id === categoryId)[0]?.children ?? []
  );

  const deleteCategory = () => {
    selectedRowKeys.forEach((index) => {
      const item = data[index];

      dispatch(
        deleteCategoryAction(item._id, () => {
          dispatch(fetchCategoriesAction());
        })
      );
    });

    setSelectedRowKeys([]);
  };

  const actions = [];

  if (selectedRowKeys.length) {
    actions.unshift({
      onClick: deleteCategory,
      title: 'Delete',
      type: 'primary'
    });
  }

  const CustomerHeader = () => {
    const options = selectedCategoryEdit
      ? selectedCategoryEdit?.descriptors?.options ?? []
      : categories.filter((category) => category._id === categoryId)[0]?.descriptors?.options ?? [];
    const name = selectedCategoryEdit
      ? selectedCategoryEdit.name
      : categories.filter((category) => category._id === categoryId)[0]?.name ?? '';
    const { _id, ancestors, parentId } = selectedCategoryEdit;
    return (
      <div style={{ display: 'flex' }}>
        <div className={classes.gridContainer}>
          <div className={classes.gridHeader}>
            <span className={classes.span}>{name || '-'}</span>
            <p className={classes.p}>
              ID: <span style={{ color: 'black' }}>{_id || '-'}</span>
            </p>
          </div>
          <div className={classes.gridHeader}>
            <span className={classes.span}>{ancestors?.name || '-'}</span>
            <p className={classes.p}>
              ID: <span style={{ color: 'black' }}>{parentId || '-'}</span>
            </p>
          </div>
          <div className={classes.gridHeader}>
            <span className={classes.span}>Options</span>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              {options
                ? options.map((option, index) => {
                    if (index + 1 === options.length) {
                      return (
                        <p key={index} className={classes.p}>
                          {option || '-'}
                        </p>
                      );
                    }
                    return (
                      <p key={index} className={classes.p} style={{ marginRight: '5px' }}>
                        {`${option}/` || '-'}
                      </p>
                    );
                  })
                : null}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const CustomerBody = () => {
    let { brand, gender, condition } = false;
    if (!selectedCategoryDraft?.descriptors) {
      brand = selectedCategoryDraft?.ancestors?.descriptors?.brand;
      gender = selectedCategoryDraft?.ancestors?.descriptors?.gender;
      condition = selectedCategoryDraft?.ancestors?.descriptors?.condition;
    } else {
      brand = selectedCategoryDraft?.descriptors?.brand;
      gender = selectedCategoryDraft?.descriptors?.gender;
      condition = selectedCategoryDraft?.descriptors?.condition;
    }
    return (
      <div className={classes.actionBar} style={{ marginTop: '55px' }}>
        <span className={classes.span}>
          Brand {brand ? <strong>ON</strong> : <strong>OFF</strong>}
          <Switch
            className={classes.switch}
            defaultChecked={brand}
            disabled={!selectedCategoryEdit.descriptors}
            onChange={(value) => {
              dispatch(
                updateCategoryAction(
                  selectedCategoryEdit._id,
                  {
                    ...selectedCategoryDraft,
                    descriptors: {
                      ...selectedCategoryDraft.descriptors,
                      brand: value
                    }
                  },
                  () => {
                    dispatch(
                      setCategoryDraft({
                        ...selectedCategoryDraft,
                        descriptors: {
                          ...selectedCategoryDraft.descriptors,
                          brand: value
                        }
                      })
                    );
                  }
                )
              );
            }}
          />
        </span>

        <span className={classes.span}>
          Gender {gender ? <strong>ON</strong> : <strong>OFF</strong>}
          <Switch
            className={classes.switch}
            defaultChecked={gender}
            disabled={!selectedCategoryEdit.descriptors}
            onChange={(value) => {
              dispatch(
                updateCategoryAction(
                  selectedCategoryEdit._id,
                  {
                    ...selectedCategoryDraft,
                    descriptors: {
                      ...selectedCategoryDraft.descriptors,
                      gender: value
                    }
                  },
                  () => {
                    dispatch(
                      setCategoryDraft({
                        ...selectedCategoryDraft,
                        descriptors: {
                          ...selectedCategoryDraft.descriptors,
                          gender: value
                        }
                      })
                    );
                  }
                )
              );
            }}
          />
        </span>

        <span className={classes.span}>
          Condition {condition ? <strong>ON</strong> : <strong>OFF</strong>}
          <Switch
            className={classes.switch}
            defaultChecked={condition}
            disabled={!selectedCategoryEdit.descriptors}
            onChange={(value) => {
              dispatch(
                updateCategoryAction(
                  selectedCategoryEdit._id,
                  {
                    ...selectedCategoryDraft,
                    descriptors: {
                      ...selectedCategoryDraft.descriptors,
                      condition: value
                    }
                  },
                  () => {
                    dispatch(
                      setCategoryDraft({
                        ...selectedCategoryDraft,
                        descriptors: {
                          ...selectedCategoryDraft.descriptors,
                          condition: value
                        }
                      })
                    );
                  }
                )
              );
            }}
          />
        </span>
      </div>
    );
  };

  const isLoaded = useSelector(({ categories }) => categories.isLoaded);

  if (!isLoaded) {
    return <Loader />;
  }

  return (
    <Layout style={{ background: 'white' }}>
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '35px 40px 0px 35px'
        }}
      >
        <Breadcrumb
          itemRender={itemRender}
          routes={routes}
          separator={<img alt="separator icon" src={ArrowNextIcon} />}
          style={{
            background: 'white',
            display: 'flex',
            justifyContent: 'flex-start'
          }}
        />
        <CButton onClick={() => setOpenModal(true)} type="primary">
          Edit
        </CButton>
      </div>
      <div style={{ margin: '55px 0px', padding: '0px 40px 0px 35px' }}>
        <CustomerHeader />
        <CustomerBody />
      </div>
      <NoxTable
        actions={actions}
        columns={columns}
        data={data}
        dragAndDropUrl="category"
        isDragAndDropEnabled
        loading={!isLoaded}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
      <Modal
        footerActions={
          <>
            <CButton onClick={() => setOpenModal(false)} type="secondary">
              Cancel
            </CButton>
            <CButton
              onClick={() => {
                dispatch(
                  updateCategoryAction(selectedCategoryDraft._id, selectedCategoryDraft, () => {
                    dispatch(fetchCategoryAction(selectedCategoryEdit._id));
                  })
                );
                setOpenModal(false);
              }}
              type="primary"
            >
              Save
            </CButton>
          </>
        }
        handleClose={() => setOpenModal(false)}
        isModalOpen={openModal}
        styles={{
          '& .MuiDialogContent-root': {
            display: 'flex',
            flexDirection: 'column',
            height: 300,
            justifyContent: 'space-evenly',
            paddingTop: '0px'
          },
          width: '400px'
        }}
        titleContent={<p className="modal-title">Edit Category</p>}
      >
        <CStandardInput
          defaultValue={selectedCategoryEdit?.name ?? ''}
          disableUnderline
          formclasses={{ root: classes.root }}
          htmlFor="standard-input-user-email"
          id="standard-input-user-email"
          label="Category Name"
          onChange={(e) => {
            dispatch(
              setCategoryDraft({
                ...selectedCategoryDraft,
                name: e.target.value
              })
            );
          }}
          size="large"
          width="true"
        />

        <CStandardInput
          defaultValue={selectedCategoryEdit?.nameGe ?? ''}
          disableUnderline
          formclasses={{ root: classes.root }}
          htmlFor="standard-input-user-email"
          id="standard-input-user-email"
          label="Category Name On Georgian"
          onChange={(e) => {
            dispatch(
              setCategoryDraft({
                ...selectedCategoryDraft,
                nameGe: e.target.value
              })
            );
          }}
          size="large"
          width="true"
        />

        <CStandardInput
          defaultValue={selectedCategoryEdit?.type ?? ''}
          disableUnderline
          formclasses={{ root: classes.root }}
          htmlFor="standard-input-user-email"
          id="standard-input-user-email"
          label="Category Type"
          onChange={(e) => {
            dispatch(
              setCategoryDraft({
                ...selectedCategoryDraft,
                type: e.target.value
              })
            );
          }}
          size="large"
          width="true"
        />

        <div className={classes.gridHeaderSwitch}>
          <p className={classes.gridHeaderSelect}>Options</p>
          <MultipleSelect
            currentValue={selectedCategoryDraft?.descriptors?.options || []}
            handleChange={(value) => {
              dispatch(
                setCategoryDraft({
                  ...selectedCategoryDraft,
                  descriptors: {
                    ...selectedCategoryDraft.descriptors,
                    options: value
                  }
                })
              );
            }}
            selectOptions={optionsMap}
            type="chip"
          />
        </div>
      </Modal>
    </Layout>
  );
};

export default CategoryDetail;
